import React, { useState, useEffect } from "react";
import axios from "axios";
import { FaClock, FaHourglassStart, FaMapMarkerAlt } from "react-icons/fa";
import { MdDateRange } from "react-icons/md";

const NotApprovedPage = () => {
  const [events, setEvents] = useState([]);
  useEffect(() => {
    fetchEvents();
  }, []);
  const fetchEvents = async () => {
    try {
      const response = await axios.get(
        "/events/get_trainer_notapproved_events",
        {
          params: {
            member_id: sessionStorage.getItem("member_id"),
          },
        }
      );
      setEvents(response.data);
    } catch (error) {
      console.error("Error fetching LOM Presidents:", error);
    }
  };
  function formatDate(inputDate) {
    const date = new Date(inputDate);

    const dayName = date.toLocaleDateString("en-US", { weekday: "short" });
    const day = date.getDate().toString().padStart(2, "0");
    const monthName = date.toLocaleDateString("en-US", { month: "short" });
    const year = date.getFullYear();

    return `${dayName}, ${day} ${monthName} ${year}`;
  }
  return (
    <div className="p-4">
      <h2 className="text-xl font-semibold">Hold</h2>

      <div className="mt-16 md:mt-4">
        {events
          ? events.map((event) => (
              <div className="mt-16 md:mt-4">
                <div className="grid grid-cols-1 md:grid-cols-6 gap-4 p-4 border rounded-lg hover:bg-[#f8f8f8] mb-2">
                  {/* Date Section */}
                  <div className="font-semibold text-lg md:border-r pr-4 mb-4 md:mb-0 text-center md:text-left">
                    <p className="text-[#93979a] text-center">
                      {formatDate(event.event_date)}
                    </p>
                  </div>
                  {/* Details Section */}
                  <div className="pl-4 mb-4 md:mb-0">
                    <div className="flex items-center mb-2">
                      <FaClock className="mr-2 text-[#93979a]" />
                      <span className="text-[#838383] font-bold text-sm">
                        {event.event_time}
                      </span>
                    </div>
                    <div className="flex items-center mb-2">
                      <FaHourglassStart className="mr-2 text-[#93979a]" />
                      <span className="text-[#838383] font-bold text-sm">
                        {event.duration} hours
                      </span>
                    </div>
                    <div className="flex items-center">
                      <FaMapMarkerAlt className="mr-2 text-[#93979a]" />
                      <span className="text-[#838383] font-bold text-sm">
                        {event.event_location}
                      </span>
                    </div>
                  </div>
                  {/* Event Section */}
                  <div className="font-bold text-sm mb-4 md:mb-0 text-center md:text-left">
                    <div>
                      <p className="text-[#838383] mb-2">{event.event_topic}</p>
                    </div>
                    <div>
                      <p className="text-[#838383]">{event.event_name}</p>
                    </div>
                  </div>
                  {/* Button Section */}
                  <div className="col-span-1 md:col-span-2 text-right mt-10 flex flex-col md:flex-row md:justify-end">
                    <p className="text-[#d02f2f] mb-2">Status : Hold</p>
                  </div>
                </div>
              </div>
            ))
          : []}
      </div>
    </div>
  );
};

export default NotApprovedPage;
